export const shouldInitializeStructuredSearchUrlHydration = (syncUrl: boolean): boolean => !syncUrl;
